var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Kein Mandant ausgewählt!")]),_vm._v("\n\tDiese Seite steht nur zur Verfügung, wenn ein Mandant ausgewählt wurde.\n")])}]

export { render, staticRenderFns }